//Adapted from https://stackoverflow.com/questions/50722368/limit-input-field-to-two-decimal-places-angular-5

import { Directive, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[decimalPointPrecision]',
})
export class DecimalPointPrecisionDirective {
    @Input('precision') precision: number;
    @Input('index') index: number;

    private specialKeys: Array<string> = [
        'Backspace',
        'Tab',
        'End',
        'Home',
        '-',
        'ArrowLeft',
        'ArrowRight',
        'Del',
        'Delete',
    ];

    constructor() {}

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        let regex: RegExp;
        if (this.precision > 0) {
            regex = new RegExp('^-?\\d*\\.?\\d{0,' + this.precision + '}$', 'g');
        } else {
            regex = new RegExp('^-?\\d+$', 'g');
        }
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        let current: string = (<HTMLInputElement>event.target).value;
        const position = (<HTMLInputElement>event.target).selectionStart;
        const next: string = [
            current.slice(0, position),
            event.key == 'Decimal' ? '.' : event.key,
            current.slice(position),
        ].join('');
        if (next && !String(next).match(regex)) {
            event.preventDefault();
            // come back to this code if we need to show an error message for reaching max precision
            //if (!isNaN(event.key)) {
            //  document.getElementById('errorPrecision' + this.index.toString()).classList.replace('hidden', null);
            //}
        }
    }
}
